const asyncTasks: { [id: string]: Promise<any> } = {};

/**
 * 加载云端脚本
 */
export async function loadRemoteScript(url: string) {
    if (asyncTasks[url]) return asyncTasks[url];

    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", url);
    script.setAttribute("charset", "utf-8");
    const task = new Promise((resolve, reject) => {
        script.onload = resolve;
        script.onerror = reject;
    });
    document.body.appendChild(script);
    asyncTasks[url] = task;
    return task;
}
